var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveredPackageIcon = function SvgDeliveredPackageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE3FF",
    d: "M8.035 25h36.789v30H8.035z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.034 25h36.789l-8.034 12H0l8.034-12Z",
    fill: "#66ACFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.966 25v12H74l-8.034-12Z",
    fill: "#3391FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#99C8FF",
    d: "M44.823 25h21.143v30H44.823z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 18h21L66 25H45l7.5-7Z",
    fill: "#66ACFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H1l7 7h21.5L22 18Z",
    fill: "#CCE3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.406 46.858h7.611v4.714h-7.611z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6h3.273L32 11h-3.273L26 6Z",
    fill: "#FFBF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42 8h3.273L48 13h-3.273L42 8Z",
    fill: "#FF4BBC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41 0h-3.273L35 5h3.273L41 0Z",
    fill: "#0075FF"
  })));
};
export default SvgDeliveredPackageIcon;